export default class TermForm extends React.Component

  constructor: (props) ->
    super(props)

    @state =
      open:   false
      id:     @props.term.id
      source: @props.term.source || @props.newSource
      target: @props.term.target || ''
      note:   @props.term.note   || ''
      saving: false
      errors: []

    @closeTerm           = @closeTerm.bind(this)
    @updateSource        = @updateSource.bind(this)
    @updateTarget        = @updateTarget.bind(this)
    @updateNote          = @updateNote.bind(this)
    @submitForm          = @submitForm.bind(this)
    @handleBackdropClick = @handleBackdropClick.bind(this)
    @handleEsc           = @handleEsc.bind(this)
    @handleEnter         = @handleEnter.bind(this)
    @handleErrors        = @handleErrors.bind(this)

  componentDidMount: ->
    @setState(open: true)
    @focusElement(@refs.sourceInput)

  focusElement: (element)->
    if element && document.activeElement != element
      element.focus()

      # Move cursor to the end
      element.setSelectionRange(element.value.length, element.value.length)

  closeTerm: ->
    @setState(open: false, =>
      setTimeout(@props.closeTerm, 200) # match the transition duration
    )

  updateSource: (e) ->
    @setState(source: e.target.value)

  updateTarget: (e) ->
    @setState(target: e.target.value)

  updateNote: (e) ->
    @setState(note: e.target.value)

  submitForm: (e) ->
    e.preventDefault() if e

    if !@state.saving
      @setState(saving: true, =>
        @props.saveTerm(
          id:     @state.id
          source: @state.source
          target: @state.target
          note:   @state.note
        , @closeTerm, @handleErrors)
      )

  handleErrors: (errors) ->
    @setState(
      saving: false
      errors: errors
    )

  handleBackdropClick: (e) ->
    @closeTerm() if e.target == e.currentTarget

  handleEsc: (e) ->
    if e.keyCode == 27 # esc
      e.stopPropagation() # prevent closing of glossary modal
      @closeTerm()  

  handleEnter: (e) ->
    if e.keyCode == 13 # enter
      e.stopPropagation()
      e.preventDefault()
      @submitForm(e)

  noChanges: ->
    # Only for updated terms
    @state.id && ['source', 'target', 'note'].every((key) =>
      @state[key] == @props.term[key] # compare term passed as props and current state
    )

  render: ->
    classes = "glossary-term-form-backdrop"
    classes += ' fade' if !@state.open

    <div className={classes} onMouseDown={@handleBackdropClick} onKeyDown={@handleEsc} tabIndex="0">
      <div className="glossary-term-form">
        {@renderTitle()}
        {@renderErrors()}
        {@renderForm()}
      </div>
    </div>

  renderTitle: ->
    if @state.id
      title = "Edit glossary term"
    else
      title = "New glossary term"
    
    <h5 className="title">
      {title}
    </h5>

  renderErrors: ->
    if @state.errors.length
      <div className="alert alert-danger">
        {_.map(@state.errors, (error, index) =>
          <div key={index}>{error}</div>
        )}
      </div>

  renderForm: ->
    <form onSubmit={@submitForm}>
      <div className="mb-3">
        <label className="form-label" htmlFor="glossary-term-source">
          Source <small>({@props.sourceLanguage.code})</small>
        </label>
        <TextareaAutosize className="form-control"
                          id="glossary-term-source"
                          ref="sourceInput"
                          minRows={1}
                          dir={if @props.sourceRightToLeft then 'rtl' else 'ltr'}
                          value={@state.source}
                          onChange={@updateSource}
                          onKeyDown={@handleEnter} />
      </div>

      <div className="mb-3">
        <label className="form-label" htmlFor="glossary-term-target">
          Target <small>({@props.targetLanguage.code})</small>
        </label>
        <TextareaAutosize className="form-control"
                          id="glossary-term-target"
                          ref="targetInput"
                          minRows={1}
                          dir={if @props.targetRightToLeft then 'rtl' else 'ltr'}
                          value={@state.target}
                          onChange={@updateTarget}
                          onKeyDown={@handleEnter} />
      </div>

      <div className="mb-3">
        <label className="form-label" htmlFor="glossary-term-note">
          Note <small>(optional)</small>
        </label>
        <TextareaAutosize className="form-control"
                          id="glossary-term-note"
                          minRows={2}
                          value={@state.note}                          
                          onChange={@updateNote} />
      </div>

      {@renderActions()}
    </form>

  renderActions: ->
    submitLabel = if @state.id then "Update" else "Create"

    <div className="actions">
      <button type="button"
              className="btn btn-cancel"
              onClick={@closeTerm}>
        Cancel
      </button>
      <button type="submit"
              className="btn btn-primary"
              disabled={@state.saving || @noChanges()}>
        {submitLabel}
      </button>
    </div>
